import React, { forwardRef } from 'react';

import MUIFormLabel, {
  FormLabelProps as MUIFormLabelProps,
} from '@material-ui/core/FormLabel';

interface FormLabelProps extends MUIFormLabelProps {}

const FormLabel = forwardRef<HTMLLabelElement, FormLabelProps>((props, ref) => {
  const { ...rest } = props;

  return (
    <MUIFormLabel {...rest} ref={ref} focused={false} error={false}>
      {props.children}
    </MUIFormLabel>
  );
});

FormLabel.displayName = 'FormLabel';

export default FormLabel;
